export enum ButtonTheme {
  MenuFilter = `menu-filter`,
  Primary = `primary`,
  // Used on the discover page. It forces the font size to medium size, independent of the button size, and also adds gray background and no borders.
  Browse = `browse`,
  Secondary = `secondary`,
  Tertiary = `tertiary`,
  Select = `select`,
  QbSubitem = `qb-subitem`,
  QueryBuilder = `query-builder`,
  MenuFooter = `menu-footer`,
  MarketingPrimary = `marketing-primary`,
  MarketingSecondary = `marketing-secondary`,
  TemplatesEvent = `templates-event`,
  WarningActions = `warning-actions`,
}

export enum ButtonSize {
  Inline = `inline`,
  Tiny = `tiny`,
  Small = `small`,
  Medium = `medium`,
  Large = `large`,
}

export enum ButtonType {
  Base = `base`,
  Destructive = `destructive`,
  Info = `info`,
  Success = `success`,
  Warn = `warn`,
  Marketing = `marketing`,
}

export enum ButtonLayout {
  Horizontal = `horizontal`,
  Vertical = `vertical`,
}
